var React = require('react');

function SchoolInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.6322 35.5898L8.68774 29.0621V19.0621L2.32666 15.5898L20.6322 5.58984L38.9933 15.5898V28.8398H36.2156V17.1732L32.5767 19.0621V29.0621L20.6322 35.5898ZM20.6322 22.4232L33.1878 15.5898L20.6322 8.83984L8.1322 15.5898L20.6322 22.4232ZM20.6322 32.4371L29.7989 27.4093V20.6454L20.6322 25.5898L11.4655 20.5898V27.4093L20.6322 32.4371Z","fill":"#0066FF"}));
}

SchoolInline.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = SchoolInline;

SchoolInline.default = SchoolInline;
